const toQueryString = <T extends object>(params: T = {} as T) => {
  // Convert object to query string
  const queryString = Object.keys(params)
    .filter((x) => {
      const value = params[x as keyof T];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return value !== undefined && value !== null && value !== "";
    })
    .map((key) => {
      const value = params[key as keyof T];
      if (value) {
        return `${key}=${encodeURIComponent(value.toString())}`;
      }
      return undefined;
    })
    .filter((x) => !!x)
    .join("&");

  return queryString;
};

export default toQueryString;
